/**
 * @generated SignedSource<<3e40c06e874adef0395c5788a7d119a9>>
 * @relayHash fa277d121f8f09e75035802d7ede6889
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a079984b25df71d288de249187cdd59463b205124f1a0a13756db6b3207ef56b

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { viewBoardCustomFiltersQuery } from './viewBoardCustomFiltersQuery.graphql';

const node: PreloadableConcreteRequest<viewBoardCustomFiltersQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "a079984b25df71d288de249187cdd59463b205124f1a0a13756db6b3207ef56b",
    "metadata": {},
    "name": "viewBoardCustomFiltersQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
